import { render, staticRenderFns } from "./AcessarPedidoItensBtnAcoes.vue?vue&type=template&id=ad7ac846&scoped=true"
import script from "./AcessarPedidoItensBtnAcoes.vue?vue&type=script&lang=js"
export * from "./AcessarPedidoItensBtnAcoes.vue?vue&type=script&lang=js"
import style0 from "./AcessarPedidoItensBtnAcoes.vue?vue&type=style&index=0&id=ad7ac846&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7ac846",
  null
  
)

export default component.exports